import { render, staticRenderFns } from "./PlantVarietyAnnuityWillPay.vue?vue&type=template&id=c822145c&"
import script from "./PlantVarietyAnnuityWillPay.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyAnnuityWillPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports